import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core'
import { provideRouter } from '@angular/router'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { DateWeekDays, provideBricksUi } from '@enbw_bricks/ui'
import { routes } from './app.routes'
import { apiKeyInterceptor } from './shared/interceptors/api-key.interceptor'
import { loadingSpinnerInterceptor } from './shared/interceptors/loading-spinner.interceptor'
import { AbstractTrackEventsService } from './shared/services/abstract-track-events.service'
import { environment } from '../environments/environment'
import { TrackEventsService } from './shared/services/track-events.service'
import { TrackEventsServiceStub } from './shared/services/track-events-stub.service'

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: AbstractTrackEventsService,
      useClass: environment.production ? TrackEventsService : TrackEventsServiceStub,
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([apiKeyInterceptor, loadingSpinnerInterceptor])),
    provideBricksUi({
      locale: 'de-DE',
      datePickerOptions: {
        firstDayOfWeek: DateWeekDays.MONDAY,
      },
    }),
  ],
}
